import { render, staticRenderFns } from "./tabelaDeProdutosDoPedido.vue?vue&type=template&id=d4f6a0a2&scoped=true"
import script from "./tabelaDeProdutosDoPedido.vue?vue&type=script&lang=js"
export * from "./tabelaDeProdutosDoPedido.vue?vue&type=script&lang=js"
import style0 from "./tabelaDeProdutosDoPedido.vue?vue&type=style&index=0&id=d4f6a0a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f6a0a2",
  null
  
)

export default component.exports